import { SettingsInput, SpotMarketType } from 'src/graphql';

import { TSettingsData } from 'src/utils/assetsFields/assetsFields.types';
import { uploadedFilesCache } from 'src/cache/uploadedFiles';

export function prepareSettingsInput(settingsData: TSettingsData): SettingsInput {
  const {
    slotLengthMinutes,
    tickLengthSeconds,
    marketCount,
    slotLengthRealtimeSeconds,
    cloudCoverage,
    startDate,
    endDate,
    spotMarketType,
    bidOfferMatchAlgo,
    gridFeeType,
    pvUserProfile,
    currency,
  } = settingsData;

  const output: SettingsInput = {
    slotLengthMinutes,
    tickLengthSeconds,
    marketCount,
    slotLengthRealtimeSeconds,
    cloudCoverage,
    startDate,
    endDate,
    spotMarketType,
    ...(spotMarketType === SpotMarketType.TwoSided && { bidOfferMatchAlgo }),
    gridFeeType,
    currency,
  };

  if (pvUserProfile) {
    output.pvUserProfile = uploadedFilesCache.get(pvUserProfile);
  }

  return output;
}
